import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FieldsState } from '../models/fields.models';

export const getCropFieldState = createFeatureSelector<FieldsState>('fields');

export const getCropFields = createSelector(getCropFieldState, (state) => state?.cropFields || []);

export const getCropFieldSettings = createSelector(
  getCropFieldState,
  (state) => state?.settings || [],
);

export const getCropFieldSettingsTogglesByCropFieldId = createSelector(
  getCropFieldState,
  (state: FieldsState, cropFieldId: number) =>
    state.settingToggles?.find((settingToggles) => settingToggles.id === cropFieldId) ?? null,
);
